import React, { useContext } from "react";
import { MainContext } from "../App";
import BarIcon from "../icons/BarIcon";
import CloseIcon from "../icons/CloseIcon";
import SettingsIcon from "../icons/SettingsIcon";

function Menu() {
	const {
		settings,
		courses,
		user,
		setUser,
		setMenuVisible,
		setAlertData,
		category,
		setCategory,
		shop,
		table,
		setTable,
		setPopupVisible,
	} = useContext(MainContext);
	const operatorRoleLabel =
		user?.role?.name ||
		user?.role?.label ||
		user?.role?.title ||
		(parseInt(user?.role?.admin) === 1 ? "Amministratore" : "Operatore");
	const operatorName = [user?.name, user?.surname].filter(Boolean).join(" ");
	const roleAndShopLabel = [operatorRoleLabel, shop?.name].filter(Boolean).join(" · ");

	return (
		<div
			className="menu"
			onClick={(e) => {
				if (e.target === e.currentTarget) setMenuVisible(false);
			}}
		>
			<div className="content" onClick={(e) => e.stopPropagation()}>
				<div className="menu-header">
					<div className="menu-header-text">
						<div>Ciao, {operatorName}</div>
						<div className="menu-role">{roleAndShopLabel}</div>
					</div>
					<button
						className="btn btn-tertiary btn-square"
						onClick={() => setMenuVisible(false)}
					>
						<CloseIcon />
					</button>
				</div>

				<div className="scroll-content">
					{shop && table && (
						<div className="course">
							<button
								className="menu-tables-btn"
								onClick={() => {
									setTable(false);
									setMenuVisible(false);
								}}
							>
								<div className="icon">
									<BarIcon />
								</div>
								Tavoli
							</button>
						</div>
					)}
					{shop &&
						table &&
						(!settings.waiter_app.categories_menu_type ||
							settings.waiter_app.categories_menu_type == 1) &&
						courses.map((course, n) => (
							<div className="course" key={n}>
								<div className="course-name">{course.name || "Altro"}</div>
								{course.categories.map((c, i) => (
									<button
										key={i}
										onClick={() => {
											setCategory(c);
											setMenuVisible(false);
										}}
										className={
											"menu-category-btn " + (c.id == category.id ? "active" : "")
										}
									>
										{c.name}
									</button>
								))}
							</div>
						))}
				</div>
				<div className="menu-bottom">
					<button
						className="menu-settings-btn"
						title="Impostazioni"
						onClick={() => {
							setMenuVisible(false);
							setPopupVisible("settings");
						}}
					>
						<SettingsIcon />
					</button>
					<button
						className="menu-logout-btn"
						onClick={() => {
							setMenuVisible(false);
							setAlertData({
								title: "Sei sicuro?",
								message: "",
								showCancelButton: true,
								callback: async function () {
									setUser(false);
									localStorage.removeItem("waiter-user");
								},
							});
						}}
					>
						<div className="icon">
							<CloseIcon />
						</div>
						Esci
					</button>
				</div>
			</div>
		</div>
	);
}

export default Menu;
